export default __webpack_public_path__ + "static/media/hht2_ani_20.7aef957f.png";